import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-certificate';
	$(base, context).each(function(){
		var component = $(this);
		var links = component.find(base + '-link');

		links.on('click', function(e) {
			e.preventDefault();

			var link = $(this);
			var item = link.parent('li');

			if (item.closest('.b-certificate-list').hasClass('i-certificate-activeList')) {
				item.appendTo(base + '-allList');
			} else {
				component.find(base + '-activeList').find('li').appendTo(base + '-allList');
				item.appendTo(base + '-activeList');
			}
		});
	});
});
